import { render, staticRenderFns } from "./veHqBaoxiuEdit.vue?vue&type=template&id=725b6fce&scoped=true"
import script from "./veHqBaoxiuEdit.vue?vue&type=script&lang=js"
export * from "./veHqBaoxiuEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "725b6fce",
  null
  
)

export default component.exports